import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import './AppLayout.css';

const AppLayout = () => {
  return (
    <div className="fd-app-layout-container">
      <Sidebar />
      <div className="fd-app-main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AppLayout;
